import * as exFile from '../files';
import * as exRequest from '../request';

export default function toBase64(url: string, config: Record<string, any> = {}): void {
    // Request XHR
    exRequest.xhr({
        merge: config.xhr,
        url: url,
        responseType: 'blob',
        fnSuccess: function (dataUrl): any {
            // File reader
            void exFile.reader(dataUrl, {
                readType: 'readAsDataURL',
                fnSuccess: function (dataFile): any {
                    // If using function done
                    if (typeof config.fnDone === 'function') {
                        config.fnDone(dataFile);
                    }
                },
                fnError: function (evt): any {
                    // If using function fail
                    if (typeof config.fnFail === 'function') {
                        config.fnFail(evt);
                    }
                },
            });
        },
    });
}
